import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/video file.svg` */
export const VideoFileIcon = createTripletGlyphIcon('VideoFileIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.1123 5.83301C6.11521 5.31993 6.6723 5.00215 7.11523 5.26074L10.8721 7.45703C11.315 7.7159 11.3119 8.35696 10.8662 8.61133L7.08398 10.7676C6.63821 11.0216 6.08519 10.6985 6.08789 10.1855L6.1123 5.83301Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.34277 1.3418C11.8651 1.52037 14.6659 4.43331 14.666 8L14.6572 8.34277C14.4787 11.8651 11.5667 14.6658 8 14.666L7.65625 14.6572C4.24775 14.4841 1.5146 11.7514 1.3418 8.34277L1.33301 8C1.33317 4.31834 4.31834 1.33317 8 1.33301L8.34277 1.3418ZM8 2.43262C4.92586 2.43278 2.43278 4.92586 2.43262 8C2.43279 11.0741 4.92586 13.5662 8 13.5664C11.0741 13.5662 13.5662 11.0741 13.5664 8C13.5662 4.92586 11.0741 2.43279 8 2.43262Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.87598 6.5625C6.87925 5.98516 7.50652 5.62768 8.00488 5.91895L12.2314 8.38867C12.7297 8.67986 12.7258 9.40126 12.2246 9.6875L7.96973 12.1143C7.46816 12.3999 6.84537 12.0352 6.84863 11.458L6.87598 6.5625Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5ZM9 2.59961C5.46538 2.59961 2.59961 5.46538 2.59961 9C2.59961 12.5346 5.46538 15.4004 9 15.4004C12.5346 15.4004 15.4004 12.5346 15.4004 9C15.4004 5.46538 12.5346 2.59961 9 2.59961Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.45205 9.075C9.45597 8.38219 10.2084 7.95292 10.8064 8.30244L15.8777 11.2661C16.4758 11.6156 16.4709 12.482 15.8689 12.8253L10.7643 15.7362C10.1624 16.0795 9.41498 15.6431 9.41865 14.9505L9.45205 9.075Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 4.35C7.77502 4.35 4.35 7.77502 4.35 12C4.35 16.225 7.77502 19.65 12 19.65C16.225 19.65 19.65 16.225 19.65 12C19.65 7.77502 16.225 4.35 12 4.35Z"
        fill="currentColor"
      />
    </svg>
  ),
});
